import {
  ECommuteDistanceType,
  EHeatingSourceType,
  EHouseMaterialType,
  EOtherCommunications,
  EReadyStatus,
  ESaleStatus,
  EWcLocationType,
} from '../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { ROAD_SAVED_FILTERS, SavedFiltersIds, STATION_SAVED_FILTERS } from '../../interfaces/filters';
import { IThunkActionCreator } from '../../types/store';
import {
  changeAreaFromFilter,
  changeAreaToFilter,
  changeBlackFridayTypeFilter,
  changeCommuteDistance,
  changeCommuteDistanceType,
  changeFloorCountFromFilter,
  changeFloorCountToFilter,
  changeHeatingSourceTypeFilter,
  changeHouseMaterialFilter,
  changeOtherCommunicationFilter,
  changePage,
  changeQueryString,
  changeReadyStatusFilter,
  changeRoadDistance,
  changeRoadFilter,
  changeSaleStatusFilter,
  changeStationDistance,
  changeStationFilter,
  changeWcLocationTypeFilter,
  removeBuilderIdFilter,
  removeLocationId,
  removeSubroads,
} from '../filters/actions';
import { ISavedFilter, justRemoveSavedFilter } from './actions';

export function removeSavedFilter(payload: ISavedFilter, reload: boolean = false): IThunkActionCreator {
  return async (dispatch, getState) => {
    const { savedFilters } = getState();
    dispatch(justRemoveSavedFilter(payload));

    // Удаляем доп фильтры
    // tslint:disable-next-line:switch-default
    switch (payload.id) {
      case SavedFiltersIds.Location:
        dispatch(removeLocationId());
        break;
      case SavedFiltersIds.SaleStatus:
        dispatch(changeSaleStatusFilter(payload.name as ESaleStatus));
        break;
      case SavedFiltersIds.ReadyStatus:
        dispatch(changeReadyStatusFilter(payload.name as EReadyStatus));
        break;
      case SavedFiltersIds.OtherCommunications:
        dispatch(changeOtherCommunicationFilter(payload.name as EOtherCommunications));
        break;
      case SavedFiltersIds.HouseMaterialType:
        dispatch(changeHouseMaterialFilter(payload.name as EHouseMaterialType));
        break;
      case SavedFiltersIds.FloorCount:
        dispatch(changeFloorCountFromFilter());
        dispatch(changeFloorCountToFilter());
        break;
      case SavedFiltersIds.Area:
        dispatch(changeAreaFromFilter());
        dispatch(changeAreaToFilter());
        break;
      case SavedFiltersIds.BuilderId:
        dispatch(removeBuilderIdFilter());
        break;
      case SavedFiltersIds.HeatingSourceType:
        dispatch(changeHeatingSourceTypeFilter(payload.name as EHeatingSourceType));
        break;
      case SavedFiltersIds.WcLocationType:
        dispatch(changeWcLocationTypeFilter(payload.name as EWcLocationType));
        break;
      case SavedFiltersIds.Road:
        if (typeof payload.value === 'number') {
          dispatch(changeRoadFilter(payload.value || 0));
        }
        break;
      case SavedFiltersIds.RoadDistance:
        savedFilters.items.forEach(filter => {
          if (!!filter.value && ROAD_SAVED_FILTERS.includes(filter.id)) {
            dispatch(removeSavedFilter(filter));
          }
        });
        dispatch(changeRoadDistance());
        break;
      case SavedFiltersIds.GroupedRoad:
        if (typeof payload.value === 'number') {
          dispatch(removeSubroads(payload.value || 0));
        }
        break;
      case SavedFiltersIds.Station:
        if (typeof payload.value === 'number') {
          dispatch(changeStationFilter(payload.value || 0));
        }
        break;
      case SavedFiltersIds.StationDistance:
        savedFilters.items.forEach(filter => {
          if (!!filter.value && STATION_SAVED_FILTERS.includes(filter.id)) {
            dispatch(removeSavedFilter(filter));
          }
        });
        dispatch(changeStationDistance());
        break;
      case SavedFiltersIds.GroupedStation:
        // Схлопнутые станции ходят массивом айдишников
        if (Array.isArray(payload.value)) {
          payload.value.forEach(id => dispatch(changeStationFilter(id)));
        }
        break;
      case SavedFiltersIds.CommuteDistance:
        dispatch(changeCommuteDistanceType(ECommuteDistanceType.Road));
        dispatch(changeCommuteDistance({ min: undefined, max: undefined }));
        break;
      case SavedFiltersIds.BlackFriday:
        dispatch(changeBlackFridayTypeFilter(undefined));
        break;
    }

    if (reload) {
      const { filters } = getState();
      dispatch(changeQueryString({ ...filters, p: 1 }, !savedFilters.showAll, true));
    } else {
      dispatch(changePage(1, true));
    }
  };
}
